import React from 'react';
import { Box, Container, makeStyles } from '@material-ui/core';
import Page from 'src/components/Page';

import PageHeader from '../../components/PageHeader'
import Create from './Create';
import CreateIcon from '@material-ui/icons/Create';
const useStyles = makeStyles((theme) => ({
  root: {
     background: '#f7f7fa',
    minHeight: '100%',
    paddingBottom: theme.spacing(4),
    paddingTop: theme.spacing(3),
  },
}));

// Dating "EventView" ang pangalan, pero auction create page ito -- hindi event.
// Lumalabas ang pangalan ng component sa React DevTools at sa error stack,
// kaya nakakatulong kung tumutugma ito sa aktwal na page.
const AuctionCreateView = () => {
  const classes = useStyles();

  return (
    <Page className={classes.root} title="Create auction">
      <Container maxWidth="lg">
       <PageHeader icon={<CreateIcon />} title="Create Auction" subtitle="Set up a new auction" showSession />

        <Box mt={3}>
          <Create />
        </Box>
      </Container>
    </Page>
  );
};

export default AuctionCreateView;